import { render, staticRenderFns } from "./single-work-diamond.vue?vue&type=template&id=71197371&scoped=true&lang=pug&"
import script from "./single-work-diamond.vue?vue&type=script&lang=js&"
export * from "./single-work-diamond.vue?vue&type=script&lang=js&"
import style0 from "./single-work-diamond.vue?vue&type=style&index=0&id=71197371&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71197371",
  null
  
)

export default component.exports